<template>
    <fieldset>

        <legend class="review-item__legend">
            <span v-if="item.reviewee_type ==='CLINIC'" >
                <a :href="'https://doctu.ru/' + item.reviewee.city + '/clinic/' + item.reviewee.url + '/reviews'"
                   target="_blank"
                   class="comma"
                >
                    {{ currentUser.role === 'clinics' ? 'Клинике' : item.reviewee.name }}
                </a>
            </span>
            <span v-else>
                <a :href="'https://doctu.ru/' + item.reviewee.city + '/doctor/' + item.reviewee.url + '#feedback'"
                   target="_blank"
                   class="comma"
                >
                    {{ item.reviewee.name }}
                </a>
            </span>
            <div style="display: flex" v-tooltip="{content: getTooltipExt(item)}">
                <div class="review-item__legend-rating" v-html="ratingFaStars(item.rating * 5)"/>
                <b class="review-item__legend-rating">{{ (Math.round(item.rating * 5 * 10) / 10).toFixed(1) }}</b>
            </div>
        </legend>
        <div class="review-item__wrapper">
            <div class="review-item-info">
                {{item.reviewee.info}}
            </div>
            <div class="review-item-info" style="padding-bottom: 0;">
                <div><b style="font-size: 16px;">{{ item.author_name }}</b></div>
                <div><b>{{ item.created_at | formatDate }}</b></div>
            </div>
            <div class="review-item-info item-info__description" style="padding-top: 0;">
                <div class="commentTextElipsis">
                    <template v-if="item.common_text">
                        {{ item.common_text }}<br>
                    </template>
                </div>
                <div v-for="row in item.comments" style="padding-left: 50px; padding-bottom: 10px; padding-top: 10px;" class="commentText">
                    <div style="float: right; font-size: 13px"><b>{{ row.created_at | formatDate }}</b><br></div>
                    <div>
                        <b style="font-size: 16px;" v-if="row.author_type === 'CLINIC'">{{ row.author ?? 'Клиника' }}</b>
                        <b style="font-size: 16px;" v-if="row.author_type === 'NETWORK'">{{ row.author ?? 'Сеть' }}</b>
                        <b style="font-size: 16px;" v-if="row.author_type === 'DOCTOR_SITE'">Врач</b>
                        <b style="font-size: 16px;" v-if="row.author_type === 'PATIENT'">Пациент</b>

                        <small v-if="row.moderated_at && !row.published" v-tooltip.bottom-end="{content: row.reject_reason}" class="label bg-red btn-row-medium">Отклонен</small>
                        <small v-if="!row.moderated_at" class="label bg-yellow btn-row-medium">На проверке</small>

                        <button v-if="row.editable && row.id !== M.id" class="button btn-row-medium" @click="beginEditReply(row)">
                            Изменить
                        </button>
                        <button v-if="row.editable && row.id !== M.id" class="button btn-row-medium" @click="deleteReply(item, row.id)">
                            Удалить
                        </button>

                    </div>
                    <div>{{ row.text }}</div>
                </div>
            </div>
            <ValidationObserver ref="reviewComments">
                <div v-if="M.id === item.id || (item.comments.length > 0 && item.comments.map((x)=>x.id).includes(M.id) )">
                    <label v-if="M.id === '' || M.id === item.id">Новый ответ</label>
                    <label v-else>Редактирование ответа</label>

                    <vee-textarea rows="3" rules="required" v-model="M.text"/>

                    <v-loading-component v-if="M.id === '' || M.id === item.id" @click="(btn)=>newReply(item, btn)" style="margin-right: 14px">
                        <template slot-scope="{ loadingClass }">
                            <button :class="['green', loadingClass]">
                                Отправить
                            </button>
                        </template>
                    </v-loading-component>


                    <button v-if="M.id === '' || M.id === item.id" @click="suggestReply(item)" style="margin-right: 14px" class="blue">
                        Предложить ответ
                    </button>
                    <button style="margin-right: 14px"
                        @click="closeForm()"
                        v-if="M.id === '' || M.id === item.id"
                        class="button red">
                        Отменить
                    </button>

                    <button style="margin-right: 14px"
                        @click="updateReply(item)"
                        v-if="M.id !== '' && M.id !== item.id"
                        :class="['button green']">
                        Сохранить
                    </button>
                    <button style="margin-right: 14px"
                        v-if="M.id !== '' && M.id !== item.id"
                        @click="suggestReply(item)"
                        class="blue">
                        Предложить ответ
                    </button>
                    <button style="margin-right: 14px" class="button red" @click="clearM()" v-if="M.id !== '' && M.id !== item.id">
                        Отменить
                    </button>
                </div>
            </ValidationObserver>
            <div v-if="M.id === ''" class="review-item-info item-info__nav">
                <button @click="openFormReply(item)" class="button" v-if="!onLimited">Ответить</button>
                <button @click="toLimitedPage()" class="button" v-if="onLimited">Ответить <i class="text-red fas fa-lock"/></button>
            </div>
        </div>
    </fieldset>
</template>
<script>
import {mapState} from "vuex";
import SuggestReviewAnswer from "@mixins/SuggestReviewAnswer"

export default {
    mixins: [SuggestReviewAnswer],
    data: function () {
        return {
            reviewCommentAuthorTypes: {
                NETWORK: 'Ответ сети',
                CLINIC: 'Ответ клиники',
                DOCTOR: 'Ответ врача',
                PATIENT: 'Ответ пациента'
            },
            M: {
                id: '',
                created_at: '',
                text: '',
            }
        };
    },
    props:{
        item:{},
        onLimited:{default: false},
    },
    methods:{
        getTooltipExt(row) {
            if (!row.rating_extended || row.rating_extended.filter((el) => el).length <= 1) {
                return '';
            }
            if (row.reviewee_type === 'DOCTOR') {
                return `<table>
                <tr><td colspan="2" align="center">` + (Math.round(row.rating * 5 * 10) / 10).toFixed(1) + `</td></tr>
                <tr><td>Тщательность:   </td><td>&nbsp;` + this.ratingFaStars(row.rating_extended[0] * 5) + `</td></tr>
                <tr><td>Эффективность:  </td><td>&nbsp;` + this.ratingFaStars(row.rating_extended[1] * 5) + `</td></tr>
                <tr><td>Отношение:      </td><td>&nbsp;` + this.ratingFaStars(row.rating_extended[2] * 5) + `</td></tr>
                <tr><td>Информирование: </td><td>&nbsp;` + this.ratingFaStars(row.rating_extended[3] * 5) + `</td></tr>
                <tr><td>Посоветуете:    </td><td>&nbsp;` + this.ratingFaStars(row.rating_extended[4] * 5) + `</td></tr>
            </table>`
            }
            return `<table>
                <tr><td colspan="2" align="center">` + (Math.round(row.rating * 5 * 10) / 10).toFixed(1) + `</td></tr>
                <tr><td>Месторасположение:    </td><td>&nbsp;` + this.ratingFaStars(row.rating_extended[0] * 5) + `</td></tr>
                <tr><td>Персонал:             </td><td>&nbsp;` + this.ratingFaStars(row.rating_extended[1] * 5) + `</td></tr>
                <tr><td>Цена/качество:        </td><td>&nbsp;` + this.ratingFaStars(row.rating_extended[2] * 5) + `</td></tr>
                <tr><td>Комфорт пребывания:   </td><td>&nbsp;` + this.ratingFaStars(row.rating_extended[3] * 5) + `</td></tr>
                <tr><td>Посоветуете:          </td><td>&nbsp;` + this.ratingFaStars(row.rating_extended[4] * 5) + `</td></tr>
            </table>`
        },
        ratingFaStars(rating) {
            let colorClass = '';
            if (rating === null) {
                colorClass = 'grey';
            }
            let __ = '<i class="far fa-sm fa-star starsMargin ' + colorClass + '"></i> ';
            let X_ = '<i class="fas fa-sm fa-star-half-alt starsMargin ' + colorClass + '"></i> ';
            let XX = '<i class="fas fa-sm fa-star starsMargin ' + colorClass + '"></i> ';

            // @formatter:off
            if (rating === null) return __ + __ + __ + __ + __;
            else if (rating <= 0.25) return __ + __ + __ + __ + __;
            else if (rating <= 0.75) return X_ + __ + __ + __ + __;
            else if (rating <= 1.25) return XX + __ + __ + __ + __;
            else if (rating <= 1.75) return XX + X_ + __ + __ + __;
            else if (rating <= 2.25) return XX + XX + __ + __ + __;
            else if (rating <= 2.75) return XX + XX + X_ + __ + __;
            else if (rating <= 3.25) return XX + XX + XX + __ + __;
            else if (rating <= 3.75) return XX + XX + XX + X_ + __;
            else if (rating <= 4.25) return XX + XX + XX + XX + __;
            else if (rating <= 4.75) return XX + XX + XX + XX + X_;
            else return XX + XX + XX + XX + XX;
            // @formatter:on
        },
        openFormReply(item){
            this.M.id = item.id;
        },
        closeForm(){
            this.clearM()
        },
        beginEditReply(row) {
            this.M.id = row.id;
            this.M.created_at = row.created_at;
            this.M.text = row.text;
        },
        newReply(item, btn) {
            btn.startLoadingAnimation();
            this.$refs.reviewComments.validate().then(success => {
                if (!success) {
                    const el = document.querySelector(".hasError:first-of-type");
                    el.scrollIntoView({behavior: "smooth"});
                    btn.stopLoadingAnimation()
                    return;
                }
                this.axios.post('reviews/' + item.id + '/createComment', {text: this.M.text}).then((response) => {
                    btn.stopLoadingAnimation()
                    this.$emit('update-table')
                    this.clearM()
                });
            });
        },
        suggestReply(item) {
            this.M.text = this.generateAnswer(item.rating, this.M.text);
        },
        updateReply(item) {
            this.$refs.reviewComments.validate().then(success => {
                if (!success) {
                    const el = document.querySelector(".hasError:first-of-type");
                    el.scrollIntoView({behavior: "smooth"});
                    return;
                }
                this.axios.post('reviews/' + item.id + '/updateComment/' + this.M.id, {text: this.M.text}).then(() => {
                    this.$emit('update-table')
                    this.clearM()
                });
            });

        },
        deleteReply(item, commentId = this.M.id) {
            this.axios.post('reviews/' + item.id + '/deleteComment/' + commentId).then(() => {
                // this.$refs.table.update();
                this.$emit('update-table')
                this.clearM()
            });
        },
        clearM() {
            this.M.id = '';
            this.M.text = '';
            this.M.created_at = '';
        },
        toLimitedPage(){
            if(this.currentUser.role === 'clinics'){
                window.location.href = '/clinics/promo/lk-reviews'
            }else {
                window.location.href ='/network/promo/lk-reviews'
            }
        }
    },
    computed: {
        ...mapState({
            currentUser: state => state.currentUser,
        }),
    },
}

</script>
<style scoped>
.btn-row-medium {
  margin-left: 14px;
  padding: 2px 6px 2px 6px !important;
}
.starsMargin {
    margin-left: -1px;
    margin-right: -1px;
}
.commentTextElipsis {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 16;
    -webkit-box-orient: vertical;
}
legend.review-item__legend{
    display: flex;

    & .review-item__legend-rating{
        color: black;
        margin-left: 4px;
    }
}
.review-item__wrapper{
    & .review-item-info{
        display: flex;
        justify-content: space-between;
        padding: 5px 0;


        &.item-info__description{
            flex-direction: column;
             font-size: 16px;

            & .commentText{
                & small.label{
                    display: inline-block;
                    border-radius: 3px;
                    margin-bottom: 5px;

                    text-align: center;
                    white-space: nowrap;
                    text-decoration: none;
                    -webkit-user-select: none;
                    -moz-user-select: none;
                    -ms-user-select: none;
                    user-select: none;

                    color: #515151;

                    padding: 6px;

                    font: 700 13px/150% "Helvetica Neue",Helvetica,Arial,Geneva,sans-serif;
                }
            }
        }
    }
}
</style>
